var _rect, _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllVideosWeb = function SvgIllVideosWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 364,
    viewBox: "0 0 1360 364",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1523_9186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1360,
    height: 364
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 364,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1523_9186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1523_9186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -267,
    y: -36,
    width: 1921,
    height: 389
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M693.412 158.5C224.41 158.5 -121.088 282 -265.588 342V-35H1652.91V352C1449.91 270 1100.91 158.5 693.412 158.5Z",
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1523_9186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1145.76 152.889C1145.76 152.889 1144.91 154.501 1147.53 154.101L1161.7 152.683",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.7 188.114C1097.7 188.114 1096.75 182.284 1106.62 175.386C1116.48 168.489 1123.38 161.349 1126.24 157.434C1126.24 157.434 1124.81 151.846 1120.78 147.082L1126.24 144.343C1126.24 144.343 1129.09 152.198 1130.4 151.834C1131.71 151.47 1132.18 150.404 1132.18 148.379V138.742L1140.27 133.154L1148.47 142.67C1148.47 142.67 1147.29 149.688 1146.1 152.064C1144.91 154.44 1146.34 154.21 1147.53 154.089L1170.12 151.834V159.919L1147.53 163.653C1146.89 163.762 1146.46 164.368 1146.59 164.998C1147.19 168.004 1148.45 176.296 1145.67 182.55C1145.32 183.338 1145.49 183.799 1145.93 184.538C1147.83 187.751 1152.23 198.43 1148.01 203.812L1140.76 206.782L1096.52 194.175L1097.71 188.114H1097.7Z",
    fill: "#ED1B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.1 168.769C1134.1 168.769 1132.81 164.526 1127.75 165.084C1122.68 165.641 1118.99 174.175 1122.5 177.799C1126 181.424 1130.79 180.745 1134.59 173.557",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.61 173.738C1124.61 173.738 1123.69 168.211 1127.84 167.847C1132 167.483 1133.42 176.938 1128.81 177.12C1124.21 177.302 1126.09 171.29 1127.84 171.35C1129.6 171.411 1129.71 175.399 1128.1 174.357",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.7 188.115C1097.7 188.115 1096.62 184.636 1102.17 179.084C1107.72 173.532 1113.04 172.041 1119.65 164.732L1126.24 157.422L1124.99 153.968C1124.99 153.968 1123.24 150.052 1121.27 147.688",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.83 148.355C1127.83 148.355 1123.64 148.198 1124 151.931L1121.27 147.713L1120.4 145.398L1126.23 144.367L1127.82 148.367L1127.83 148.355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.18 143.385V146.294C1132.18 146.294 1136.66 141.373 1148.07 144.84L1150.12 140.27L1136.47 130.476L1129.69 141.361L1132.17 143.385H1132.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.03 152.452C1164.03 152.452 1167.31 155.786 1163.42 161.035L1169.43 159.968L1169.24 151.737L1164.03 152.452V152.452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.48 117.205C1075.48 117.205 1085.16 115.683 1091.99 121.647L1098.99 114.41C1098.99 114.41 1083.75 111.946 1081.1 107.442L1074.84 111.099L1075.5 117.201L1075.48 117.205Z",
    fill: "#ED1B98",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.06 147.24C1182.65 140.67 1167.59 136.161 1166.63 154.901C1165.81 159.144 1164.03 167.217 1173.2 170.502C1182.38 173.787 1187.02 168.587 1187.3 162.841C1187.3 162.841 1195.65 162.708 1195.79 154.635C1195.92 146.561 1185.8 144.78 1183.06 147.24Z",
    fill: "#32BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.28 137.822C1140.28 137.822 1118.42 157.386 1099.39 143.64C1080.36 129.894 1086.88 100.996 1110.31 100.111C1110.31 100.111 1116.3 83.5404 1140.28 88.6558C1140.28 88.6558 1145.56 70.1459 1169.71 71.0307C1193.86 71.9156 1193.68 95.4076 1193.68 95.4076C1193.68 95.4076 1212.53 102.244 1204.95 124.96C1197.54 141.555 1184.86 142.234 1174.28 138.706C1174.28 138.706 1162.12 155.095 1140.27 137.822H1140.28Z",
    fill: "#32BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.29 138.695C1174.29 138.695 1162.06 136.695 1160.26 121.349",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.39 126.1C1149.39 126.1 1145.12 135.409 1140.28 138.052",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.01 72.6426C1157.01 72.6426 1140.89 77.8307 1140.28 88.6554Z",
    fill: "#32BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.01 72.6426C1157.01 72.6426 1140.89 77.8307 1140.28 88.6554",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 110.693C1091.32 111.13 1091.14 111.554 1090.97 111.99C1081.02 136.707 1103.21 145.956 1103.21 145.956",
    fill: "#32BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 110.693C1091.32 111.13 1091.14 111.554 1090.97 111.99C1081.02 136.707 1103.21 145.956 1103.21 145.956",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.51 98.802C1071.51 98.802 1065.19 90.3977 1056.73 98.31C1048.27 106.222 1060.66 112.717 1060.66 112.717C1060.66 112.717 1058.39 120.953 1064.56 123.291C1070.72 125.629 1075.52 121.468 1079.37 113.469C1083.21 105.47 1085.18 105.36 1083.24 98.2621C1081.31 91.1638 1070.86 95.1959 1071.5 98.7903L1071.51 98.802Z",
    fill: "#32BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.627 131.956V127.054L311.882 122L316.936 126.971V131.956",
    fill: "#ED1B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.883 122H328.931L333.819 126.888L316.937 126.971L311.883 122Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.818 126.889H316.936V132.397H333.818V126.889Z",
    fill: "#FCAEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.146 139.24L264.912 166.382H276.314L296.598 146.098L286.146 139.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.118 165.019V195.837H315.037V157.638L362.118 165.019Z",
    fill: "#FCAEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.402 160.543L320.2 167.442H361.841V197.668",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.838 195.837V157.279L291.667 132.272L314.843 159.648V194.184L271.838 195.837Z",
    fill: "#ED1B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.061 153.08C293.533 153.08 295.537 151.076 295.537 148.604C295.537 146.133 293.533 144.129 291.061 144.129C288.59 144.129 286.586 146.133 286.586 148.604C286.586 151.076 288.59 153.08 291.061 153.08Z",
    fill: "#F6D703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.541 159.662H272.527V195.851H314.541V159.662Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.541 159.662L272.527 195.851",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.541 195.851L272.527 159.662",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.6 132.287L291.93 131.956L320.669 166.052L368.865 166.189V166.809L320.6 166.905L291.6 132.287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.603 131.915L291.93 131.956L320.668 166.052L368.865 166.19L339.603 131.915Z",
    fill: "#0066FF"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.73 113.23C1083.73 113.23 1082.44 112.379 1079.83 112.43C1077.21 112.48 1073.91 112.912 1073.91 110.296C1073.91 107.681 1074.71 105.014 1074.88 102.944C1075.04 100.875 1074.71 95.2115 1077.01 95.0591C1079.31 94.9067 1079.89 96.2273 1080.31 98.3605C1080.31 98.3605 1081.75 94.6909 1083.77 95.021C1085.78 95.3512 1085.61 96.0749 1086.01 99.1097C1086.33 100.126 1086.06 100.659 1088.2 101.243C1090.33 101.827 1096.25 103.059 1100.35 108.392C1102 111.058 1101.95 119.477 1095.4 121.293C1088.84 123.108 1086.98 120.759 1086.86 118.525C1086.79 116.912 1087.23 115.871 1087.94 115.299C1088.21 115.083 1088.51 114.931 1088.84 114.842C1090.01 114.525 1091.14 114.144 1091.14 114.144C1091.14 114.144 1087.14 114.512 1083.73 113.242V113.23Z",
    fill: "#F6D703"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1523_9186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1073,
    y: 95,
    width: 29,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.73 113.23C1083.73 113.23 1082.44 112.379 1079.83 112.43C1077.21 112.48 1073.91 112.912 1073.91 110.296C1073.91 107.681 1074.71 105.014 1074.88 102.944C1075.04 100.875 1074.71 95.2115 1077.01 95.0591C1079.31 94.9067 1079.89 96.2273 1080.31 98.3605C1080.31 98.3605 1081.75 94.6909 1083.77 95.021C1085.78 95.3512 1085.61 96.0749 1086.01 99.1097C1086.33 100.126 1086.06 100.659 1088.2 101.243C1090.33 101.827 1096.25 103.059 1100.35 108.392C1102 111.058 1101.95 119.477 1095.4 121.293C1088.84 123.108 1086.98 120.759 1086.86 118.525C1086.79 116.912 1087.23 115.871 1087.94 115.299C1088.21 115.083 1088.51 114.931 1088.84 114.842C1090.01 114.525 1091.14 114.144 1091.14 114.144C1091.14 114.144 1087.14 114.512 1083.73 113.242V113.23Z",
    fill: "#F6D703"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1523_9186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1092.96 110.284C1096.32 110.284 1099.05 107.555 1099.05 104.189C1099.05 100.823 1096.32 98.0938 1092.96 98.0938C1089.59 98.0938 1086.86 100.823 1086.86 104.189C1086.86 107.555 1089.59 110.284 1092.96 110.284Z",
    fill: "url(#paint0_radial_1523_9186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.01 113.763C1075.37 113.763 1078.1 111.034 1078.1 107.668C1078.1 104.302 1075.37 101.573 1072.01 101.573C1068.64 101.573 1065.91 104.302 1065.91 107.668C1065.91 111.034 1068.64 113.763 1072.01 113.763Z",
    fill: "url(#paint1_radial_1523_9186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.27 126.765C1094.64 126.765 1097.37 124.036 1097.37 120.67C1097.37 117.304 1094.64 114.575 1091.27 114.575C1087.9 114.575 1085.18 117.304 1085.18 120.67C1085.18 124.036 1087.9 126.765 1091.27 126.765Z",
    fill: "url(#paint2_radial_1523_9186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.7 117.483C1103.34 117.483 1105.48 115.346 1105.48 112.709C1105.48 110.072 1103.34 107.935 1100.7 107.935C1098.07 107.935 1095.93 110.072 1095.93 112.709C1095.93 115.346 1098.07 117.483 1100.7 117.483Z",
    fill: "url(#paint3_radial_1523_9186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.34 117.483C1086.97 117.483 1089.11 115.346 1089.11 112.709C1089.11 110.072 1086.97 107.935 1084.34 107.935C1081.7 107.935 1079.56 110.072 1079.56 112.709C1079.56 115.346 1081.7 117.483 1084.34 117.483Z",
    fill: "url(#paint4_radial_1523_9186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.34 100.837C1086.97 100.837 1089.11 98.6993 1089.11 96.0625C1089.11 93.4256 1086.97 91.2881 1084.34 91.2881C1081.7 91.2881 1079.56 93.4256 1079.56 96.0625C1079.56 98.6993 1081.7 100.837 1084.34 100.837Z",
    fill: "url(#paint5_radial_1523_9186)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.35 103.249C1083.28 103.249 1084.03 102.493 1084.03 101.56C1084.03 100.627 1083.28 99.8711 1082.35 99.8711C1081.41 99.8711 1080.66 100.627 1080.66 101.56C1080.66 102.493 1081.41 103.249 1082.35 103.249Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.95 103.007C1082.67 103.007 1083.25 102.427 1083.25 101.712C1083.25 100.997 1082.67 100.417 1081.95 100.417C1081.24 100.417 1080.66 100.997 1080.66 101.712C1080.66 102.427 1081.24 103.007 1081.95 103.007Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.85 103.465C1078.85 103.465 1079.46 104.976 1080.88 103.566",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1078 102.855C1078.93 102.855 1079.69 102.099 1079.69 101.166C1079.69 100.234 1078.93 99.4775 1078 99.4775C1077.07 99.4775 1076.31 100.234 1076.31 101.166C1076.31 102.099 1077.07 102.855 1078 102.855Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.61 102.614C1078.32 102.614 1078.9 102.034 1078.9 101.319C1078.9 100.603 1078.32 100.023 1077.61 100.023C1076.89 100.023 1076.31 100.603 1076.31 101.319C1076.31 102.034 1076.89 102.614 1077.61 102.614Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.78 95.0207C1083.78 95.0207 1085.45 94.7921 1085.75 96.9507C1086.04 99.1093 1084.62 100.519 1089.42 101.56C1094.21 102.601 1097.72 105.065 1099.61 107.464L1100.06 107.985",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.959 219C185.959 219 177.753 215.139 177.914 209.053C178.076 202.967 186.12 207.762 187.422 213.516C187.422 213.516 186.554 204.602 192.182 198.86C197.809 193.118 200.227 197.237 199.88 200.655C199.532 204.073 199.966 210.602 192.616 216.947L185.959 219V219Z",
    fill: "#3CC265"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M524.676 165.799C524.676 165.799 521.153 163.045 522.062 159.836C522.97 156.627 525.348 157.676 525.585 160.985C525.585 160.985 527.765 154.729 531.762 156.233C535.759 157.738 528.136 166.061 527.102 166C526.067 165.938 524.684 165.807 524.684 165.807L524.676 165.799Z",
    fill: "#32BF5E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.68 185.989C1034.68 185.989 1029.13 182.709 1030.01 174.546C1030.89 166.384 1034.39 168.478 1035.18 170.465C1035.96 172.452 1037.31 177.346 1036.82 178.596C1036.56 179.258 1037.36 179.824 1037.72 178.735C1038.07 176.801 1036.65 173.157 1036.93 171.469C1037.22 169.781 1039.96 158.434 1043.85 159.022C1047.74 159.61 1042.39 176.341 1040.15 178.435C1040.15 178.435 1045.41 172.965 1048.24 175.049C1051.06 177.132 1044.44 186 1039.56 186H1034.68V185.989Z",
    fill: "#3CC265"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.492 221.165C340.492 221.165 360.068 213.629 375.2 225.868C375.2 225.868 389.733 212.054 412.94 221.713C412.94 221.713 426.356 209.914 449.239 213.1C449.239 213.1 432.691 206.045 414.803 213.555C414.803 213.555 391.802 201.966 372.675 217.369C372.675 217.369 359.814 212.804 340.482 221.165L340.492 221.165Z",
    fill: "#F6D703"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.18 272.548C1052.18 272.548 1071.56 269.303 1083.16 283.372C1083.16 283.372 1099.09 273.418 1118.58 286.631C1118.58 286.631 1133.11 278.313 1153.52 285.539C1153.52 285.539 1139.65 275.957 1121.82 279.499C1121.82 279.499 1102.88 264.546 1082.44 275.101C1082.44 275.101 1071.49 268.497 1052.18 272.548V272.548Z",
    fill: "#F6D703"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.41 189.5C1073.41 189.5 1144.75 200.563 1183.91 209",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M917.056 206.79C917.056 206.79 939.674 204.356 952.427 220.884C952.427 220.884 971.371 210.7 993.315 226.764C993.315 226.764 1010.55 218.333 1033.85 227.712C1033.85 227.712 1018.25 216.088 997.416 218.948C997.416 218.948 976.193 200.973 951.99 211.545C951.99 211.545 939.623 203.447 917.046 206.787L917.056 206.79Z",
    fill: "#F6D703"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1523_9186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1092.96 104.189) scale(6.0949 6.09492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC1E98",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EC1E98",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EC1E98",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EC1E98",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC1E98",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1523_9186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1072.01 107.668) scale(6.0949 6.09492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EC1E98",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EC1E98",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EC1E98",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EC1E98",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EC1E98",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1523_9186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1091.27 120.67) scale(6.0949 6.09491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EC1E98",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EC1E98",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EC1E98",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EC1E98",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1523_9186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1100.7 112.709) scale(4.77433 4.77436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#32CDF1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32CDF1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#32CDF1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#32CDF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1523_9186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1084.34 112.709) scale(4.77433 4.77436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#32CDF1",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32CDF1",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#32CDF1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1523_9186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1084.34 96.0624) scale(4.77433 4.77436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32CDF1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32CDF1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32CDF1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32CDF0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllVideosWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_videos_web.e25b170c.svg";
export { ForwardRef as ReactComponent };